/**
 * @author Ariel
 * @description 培训中心场地管理
 * @Date 2020/5/27
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool } from '../../../tool';
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizModal } = component_tool;
let {  WizBrowserExport } = component_tool;


class trainSiteManager extends WizContainer {
  componentName = 'trainSiteManager';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _componentDidMount() {
    this.doAction({
      path: 'trainCenter/info',
      payload: {
        key: 'trainCenter_info',
        apiParams: {
          type: 'FOLDER'
        }
      }
    })
  }

  propsAndStateOnChange = {
    trainCenterList: this._getTrainCenterOver.bind(this)
  }

  _getTrainCenterOver(nextProps,nextState) {
    let _list = [];
    if (nextProps.trainCenterList.code === 1) {
      let list = nextProps.trainCenterList.data
      list && list.forEach(val => {
        _list.push({code: val['id'],codeName: val['name']})
      });
      nextState.trainCenterList = _list;
      return true;
    } else {
      wizNotice.error(nextProps.trainCenterList.msg)
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '场地名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '场地编号',
        field: 'code',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '场地应用类型',
        field: 'type',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '培训中心',
        field: 'trainCenterName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '城市',
        field: 'city',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '地址',
        field: 'address',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '场地状态',
        field: 'status',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      },
      {
        headerName: '受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let _data = []
      const typeMap = { '0': "教室", '1': "场地大门", '2': "餐厅", '3': "其他场所"};
      const statusMap = { '0': "正常", '1': '停止使用', '2': '维修中'};
      data && data.dataList && data.dataList.forEach(d => {
        d['type'] = typeMap[d['type']]
        d['status'] = statusMap[d['status']]
        d.anonymous = d.anonymous== 1 ? "是":"否"
        let _d = { ...d }
      let authData = d['authInfo']
      let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['scope'] = target
        _data.push(_d)
      });

      WizBrowserExport({
        title: '场地信息',
        sheetName: '场地信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '场地信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  _render() {
    let trainCenterList = {}
    if (this.state && this.state.trainCenterList && this.state.trainCenterList.length){
      trainCenterList = this.state.trainCenterList
    }
    trainCenterList._btnFun= (e) => {
      if(e && e.rows && e.rows.length && e.rows.length === 1){
        let record = {}
        e.rows.forEach(d => {
          record = d
        })
        this.jumpPage('push','/site/trainSite/siteEquipment',record)
      } else {
        WizModal.confirm({
                           title: '请选择一条数据',
                           onOk: () => {},
                           onCancel() {}
                         })
      }
    }
    
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(trainCenterList),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const {trainSite,trainCenter} = state;
  const trainCenterList = modelUtils.getModelEntity(trainCenter,'trainCenter_info');
  const load = modelUtils.getLoadingState(state, ['trainSite','trainCenter']);
  return {
    trainCenterList: trainCenterList,
    ...load
  }
};

export default connect(mapStateToProps)(trainSiteManager);
